import React, { useState, useEffect, useRef } from "react";
import "./HomeGallery.css";
import img1 from"../assets/activity/1.jpeg";
import img2 from "../assets/activity/2.jpeg";
import img3 from "../assets/activity/3.jpeg";
import img4 from "../assets/activity/4.jpeg";
import img5 from "../assets/activity/5.jpeg";
import img6 from "../assets/activity/6.jpeg";
import img7 from "../assets/activity/7.jpeg"

const activities = [
  {
    title: "Academic Activities",
    icon: "bi-journal-richtext",
    image: img1,
    description:
      "Encouraging curiosity, knowledge, creativity and intellectual growth.",
    items: [
      "Quiz competitions",
      "Debates and elocution",
      "Science and mathematics activities",
      "Project work and exhibitions",
      "Reading and creative writing",
    ],
  },
  {
    title: "Sports and Physical Education",
    icon: "bi-trophy",
    image: img2,
    description:
      "Promoting fitness, discipline, teamwork and a healthy competitive spirit.",
    items: [
      "Indoor and outdoor games",
      "Athletics and sports competitions",
      "Yoga and fitness activities",
      "Team games and sports events",
    ],
  },
  {
    title: "Cultural Activities",
    icon: "bi-music-note-beamed",
    image: img3,
    description:
      "Providing opportunities for students to express their talents and creativity.",
    items: [
      "Dance and music performances",
      "Art and craft competitions",
      "Drama and role-play",
      "Cultural programmes and talent showcases",
    ],
  },
  {
    title: "National and Special Day Celebrations",
    icon: "bi-flag",
    image: img4,
    description:
      "Building patriotism, respect and awareness of important occasions.",
    items: [
      "Independence Day and Republic Day",
      "Teachers’ Day and Children’s Day",
      "National and international observances",
      "Birth anniversaries of eminent personalities",
    ],
  },
  {
    title: "Environmental Awareness",
    icon: "bi-tree",
    image: img5,
    description:
      "Developing environmental responsibility and care for nature.",
    items: [
      "Tree plantation and nature awareness",
      "Cleanliness drives",
      "Waste management and recycling activities",
      "Environmental awareness campaigns",
    ],
  },
  {
    title: "Social Awareness and Community Engagement",
    icon: "bi-people",
    image: img6,
    description:
      "Nurturing empathy, kindness and responsibility towards society.",
    items: [
      "Educational visits",
      "Awareness campaigns and rallies",
      "Activities promoting kindness, empathy, and responsibility",
      "Community service initiatives",
    ],
  },
  {
    title: "Pre-Primary Activities",
    subtitle: "LKG and UKG",
    icon: "bi-balloon",
    image: img7,
    description:
      "Making early learning joyful through play, creativity and interaction.",
    items: [
      "Rhymes, storytelling, and action songs",
      "Colouring and creative activities",
      "Festival celebrations",
      "Show-and-tell and theme-based activities",
      "Games promoting motor skills and social interaction",
    ],
  },
];


const galleryImages = [
  {
    src: img1,
    alt: "Students participating in a school activity",
  },
  {
    src: img2,
    alt: "School event and student participation",
  },
  {
    src:img3,
    alt: "Students learning beyond the classroom",
  },
  {
    src: img4,
    alt: "Students enjoying a learning activity",
  },
  {
    src:img5,
    alt: "School academic activities",
  },
  {
    src: img6,
    alt: "School extracurricular activities",
  },
];

const HomeGallery = () => {
  const activitiesRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  // ACTIVITY SLIDER NAVIGATION
  const scrollActivities = (direction) => {
    const slider = activitiesRef.current;

    if (!slider) return;

    const card = slider.querySelector(".activity-card");

    if (!card) return;

    const styles = window.getComputedStyle(slider);
    const gap = parseFloat(styles.columnGap) || 24;
    const scrollAmount = card.offsetWidth + gap;

    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (direction === 1 && slider.scrollLeft >= maxScroll - 5) {
      slider.scrollTo({
        left: 0,
        behavior: "smooth",
      });
      return;
    }

    if (direction === -1 && slider.scrollLeft <= 5) {
      slider.scrollTo({
        left: maxScroll,
        behavior: "smooth",
      });
      return;
    }

    slider.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  };

  // AUTOMATIC ACTIVITY SCROLLING
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      scrollActivities(1);
    }, 3500);

    return () => clearInterval(interval);
  }, [isPaused]);

  // LIGHTBOX NAVIGATION
  const closePopup = () => {
    setActiveIndex(null);
  };

  const showNext = (e) => {
    e?.stopPropagation();

    setActiveIndex((prev) =>
      prev === null ? null : (prev + 1) % galleryImages.length
    );
  };

  const showPrev = (e) => {
    e?.stopPropagation();

    setActiveIndex((prev) =>
      prev === null
        ? null
        : (prev - 1 + galleryImages.length) % galleryImages.length
    );
  };

  // LIGHTBOX KEYBOARD CONTROLS
  useEffect(() => {
    if (activeIndex === null) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") closePopup();
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [activeIndex]);

  return (
    <>
      {/* =================================
          SCHOOL ACTIVITIES SECTION
      ================================== */}

      <section
        className="school-activities-section"
        id="school-activities"
      >
        <div className="container">

          {/* SECTION HEADING */}

          <div className="activities-heading">

            <h2>
              School <span>Activities</span>
            </h2>

            <p>
              At Air Force School, Vayu Sena Nagar, Nagpur, activities
              beyond academics play an important role in the holistic
              development of students. The school provides opportunities
              for students to explore their interests, discover their
              talents, develop leadership skills, and build confidence.
            </p>
          </div>

          {/* SLIDER CONTROLS */}

          <div className="activities-slider-header">
            <div className="activities-slider-controls">

              <button
                type="button"
                onClick={() => scrollActivities(-1)}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                aria-label="Previous activities"
              >
                <i className="bi bi-arrow-left"></i>
              </button>

              <button
                type="button"
                onClick={() => scrollActivities(1)}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                aria-label="Next activities"
              >
                <i className="bi bi-arrow-right"></i>
              </button>

            </div>
          </div>

          {/* ACTIVITY CARDS SLIDER */}

          <div className="activities-slider">

            <div
              className="activities-grid"
              ref={activitiesRef}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
              onTouchStart={() => setIsPaused(true)}
              onTouchEnd={() => setIsPaused(false)}
            >

              {activities.map((activity, index) => (
                <article
                  className="activity-card"
                  key={activity.title}
                >

                  {/* IMAGE */}

                  <div className="activity-image">
                    <img
                      src={activity.image}
                      alt={activity.title}
                      loading="lazy"
                    />
                  </div>

                  {/* CONTENT */}

                  <div className="activity-content">

                    <h3>{activity.title}</h3>

                    {activity.subtitle && (
                      <span className="activity-subtitle">
                        {activity.subtitle}
                      </span>
                    )}

                    <p className="activity-description">
                      {activity.description}
                    </p>

                    <ul>
                      {activity.items.map((item, i) => (
                        <li key={i}>
                          <i className="bi bi-check-circle-fill"></i>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>

                  </div>
                </article>
              ))}

            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default HomeGallery;